<template>
  <v-footer
    color="primary"
    class="pa-1 app-font-size"
    dark
    :app="$vuetify.breakpoint.smAndUp"
  >
    <v-flex text-center>
      <span>
        &copy; {{$t('footerLabels.mainFooterLabel', [getCurrentYear])}}
      </span>
    </v-flex>
  </v-footer>
</template>

<script>
export default {
  name: 'sat-footer',
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<i18n>
{
  "en": {
    "footerLabels": {
      "mainFooterLabel": "{0} Bensussen Deutsch & Associates, LLC."
    }
  }
}
</i18n>
